module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightIt.0b7008b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLightIt.woff2
// module id = 320
// module chunks = 3